import { Grid } from '@material-ui/core';
import * as React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { GameState } from './common/life';
import Patterns from './common/patterns';
import LifeGrid from './components/LifeGrid';
import LifeInfo from './components/LifeInfo';
import NavBar from './components/NavBar';
import { Messages } from './store/life';

import './App.css';

interface AppProps {
  game: GameState,
}

interface AppState {
  events: any,
}

class App extends React.Component<AppProps & DispatchProp, AppState> {

  constructor(props: AppProps & DispatchProp) {
    super(props);

    const patternEvents: {[index: string]: () => void} = {};
    Object.keys(Patterns).forEach(key => {
      patternEvents[key] = () => props.dispatch(
        Messages.placePattern(Patterns[key]));
    })

    this.state = {
      events: {
        dispatch: () => props.dispatch,
        patterns: patternEvents,
        evolve: () => props.dispatch(Messages.evolveLife(false)),
        evolveForce: () => props.dispatch(Messages.evolveLife(true)),
        resetClear: () => props.dispatch(Messages.resetClear()),
        resetRandomized: () => props.dispatch(Messages.resetRandomized()),
        suspendLife: () => props.dispatch(Messages.suspendLife()),
        toggleLife: () => props.dispatch(Messages.toggleLife()),
      }
    }
  }

  public componentDidMount() {
    this.letThereBeLife();
  }

  public render = () => (
    <div className="root">
      <NavBar game={this.props.game} events={this.state.events} />

      <Grid container={true} spacing={24} className="padded">
        <Grid item={true} xs={12} md={6}>
          <LifeGrid game={this.props.game} events={this.state.events} />
        </Grid>
        <Grid item={true} xs={12} md={6}>
          <LifeInfo events={this.state.events} />
        </Grid>
      </Grid>
    </div>)

  public letThereBeLife() {
    setTimeout(() => this.letThereBeLife(), this.props.game.rate );
    this.state.events.evolve();
  }
}

const mapStateToProps = (state: GameState) => ({ game: state });

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.tsx